/**
 * Apartados del informe que están en actualización (ADR-014).
 *
 * «Probabilidad de accidente» y «Exposición a hurto» se conservan en la
 * pantalla y en el HTML, pero solo dicen «En actualización» mientras el módulo
 * estadístico se desarrolla y valida. No llevan porcentaje, rango, color ni
 * conclusión que se pueda leer como una probabilidad validada o como una
 * clasificación de hurto.
 *
 * El texto es uno solo para todos los formatos: así una prueba puede exigir
 * exactamente esta cadena y ningún camino alternativo publica otra cosa.
 */

/** El texto exacto que muestran los dos apartados. */
export const EN_ACTUALIZACION = "En actualización" as const;

/** Rótulos de los dos apartados, iguales en pantalla y en HTML. */
export const ACCIDENT_PROBABILITY_LABEL = "Probabilidad de accidente" as const;
export const THEFT_EXPOSURE_LABEL = "Exposición a hurto" as const;

/**
 * Política del apartado de hurto. Hoy solo existe `EN_ACTUALIZACION`: no hay un
 * cálculo validado de exposición a hurto que publicar. El valor anterior, un
 * «No concluyente» con una nota sobre zonas seguras, se retiró porque sugería
 * una clasificación que no existe.
 */
export type TheftExposurePolicy = "EN_ACTUALIZACION";
export const THEFT_EXPOSURE_POLICY: TheftExposurePolicy = "EN_ACTUALIZACION";
